import React from 'react';

import { LazyNBMPage } from '@confluence/nbm-migration/entry-points/NBMPage';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';

export const AdminNBMMigrationRoute = () => <LazyNBMPage />;

AdminNBMMigrationRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: 'adminNBMMigration' },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
